import React from 'react'
import {SymbolLabel} from '../../label/SymbolLabel'
import {useNavigate} from 'react-router-dom'
import { useScreenType } from '../../../../../../../../helpers/hooks/useScreenType'
import { textColors } from '../../../../../../../../interfaces/_models'
import { KTSVG } from '../../../../../../../../template/_metronic/helpers'

type Props = {
  title: string
  description: string
  icon: string
  color: string
}

export const HorizontalTableRow = ({title, description, icon, color}: Props) => {
  const navigate = useNavigate()
  const screenType = useScreenType()
  return (
    <label className='d-flex flex-stack mb-5 cursor-pointer horizontal-table-label'>
      <SymbolLabel
        title={title}
        icon={icon}
        className={'me-2'}
      />
      <span className='d-flex justify-content-end'>
        {screenType !== 'mobile' && <span className='fw-semibold me-1 text-gray fs-2'>Total:</span>}

        <span className={`${screenType !== 'mobile' && 'w-150px'}`}>
          <span
            className={`w-100 d-flex justify-content-end fw-semibold fs-2 ${textColors.get(color)}`}
          >
            {description}
          </span>
        </span>
      </span>
      {color === 'danger' && screenType !== 'mobile' && (
        <span className='error-button' onClick={()=> navigate('/upload-file/users-with-error')}>
          <KTSVG path='/media/soyfri-media/arrow-right-short.svg' />
        </span>
      )}
    </label>
  )
}
